import React from 'react';

const MenuThreeDotsInlineIcon = ({
    width,
    height,
    backgroundColor,
    ...extra
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 -135 369.91339 369" width={width} {...extra}>
        <path d="m369.277344 42.027344c4.367187 26.945312-13.933594 52.328125-40.878906 56.695312-26.945313 4.371094-52.328126-13.933594-56.695313-40.875-4.367187-26.945312 13.933594-52.328125 40.878906-56.695312 26.945313-4.367188 52.328125 13.933594 56.695313 40.875zm0 0" fill={backgroundColor} />
        <path d="m234.421875 49.886719c0 27.296875-22.128906 49.429687-49.429687 49.429687-27.296876 0-49.425782-22.132812-49.425782-49.429687 0-27.300781 22.128906-49.429688 49.425782-49.429688 27.300781 0 49.429687 22.128907 49.429687 49.429688zm0 0" fill={backgroundColor} />
        <path d="m84.382812 14.933594c19.304688 19.304687 19.304688 50.601562 0 69.90625-19.304687 19.304687-50.601562 19.304687-69.90625 0-19.300781-19.304688-19.300781-50.601563 0-69.90625 19.304688-19.300782 50.601563-19.300782 69.90625 0zm0 0" fill={backgroundColor} />
    </svg>
);
export default MenuThreeDotsInlineIcon;
